import { CHAT_LABEL_UNKNOWN_CHAT } from '@features/components/Chat/constants';

type PanelTitleProps = {
  title: string;
  count?: number;
  image?: string;
  chatName?: string;
};

export const PanelTitle = ({ title, count, image, chatName }: PanelTitleProps) => (
  <div className="flex items-center gap-2">
    {image && <img src={image} alt="Chat Avatar" className="chat-avatar rounded-full w-8 h-8" />}
    <div className="flex flex-col">
      <p className="text-m-m whitespace-normal">
        {title} {count !== undefined && `(${count})`}
      </p>
      <span className="text-s-r text-base-25">{chatName || CHAT_LABEL_UNKNOWN_CHAT}</span>
    </div>
  </div>
);
